import React from "react";

const FormstackIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.0188 3.29999C29.113 3.29999 30 4.18702 30 5.28124V34.6521C30 35.7463 29.113 36.6333 28.0188 36.6333H1.98125C0.887036 36.6333 0 35.7463 0 34.6521V5.28124C0 4.18702 0.887036 3.29999 1.98125 3.29999H28.0188ZM34 6.63332C34.5523 6.63332 35 7.08104 35 7.63332V32.3C35 32.8523 34.5523 33.3 34 33.3H31.6667V6.63332H34ZM39 9.96666C39.5523 9.96666 40 10.4144 40 10.9667V28.9667C40 29.5189 39.5523 29.9667 39 29.9667H36.6667V9.96666H39Z",
  fill: "#21B573"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9401 27.4147C11.9791 27.4706 12 27.5371 12 27.6053V30.9928C12 31.1769 11.8507 31.3262 11.6666 31.3262H6.98808C6.81054 31.3262 6.66663 31.1822 6.66663 31.0047V30.8573C6.66663 30.7482 6.71994 30.6461 6.80938 30.5838L11.476 27.3318C11.6271 27.2265 11.8349 27.2637 11.9401 27.4147ZM19.6299 19.6334C19.814 19.6334 19.9632 19.7826 19.9632 19.9667C19.9632 20.0765 19.9092 20.1792 19.8187 20.2414L7.18878 28.923C7.03707 29.0272 6.82955 28.9888 6.72526 28.8371C6.68707 28.7815 6.66663 28.7157 6.66663 28.6483V23.4855C6.66663 23.3831 6.71364 23.2864 6.79415 23.2233L11.2771 19.7045C11.3358 19.6584 11.4083 19.6334 11.4829 19.6334H19.6299ZM22.383 8.63336C22.5671 8.63336 22.7164 8.7826 22.7164 8.9667C22.7164 9.06796 22.6703 9.16373 22.5913 9.22698L7.20819 21.5334C7.06444 21.6484 6.85467 21.6251 6.73967 21.4814C6.69239 21.4223 6.66663 21.3488 6.66663 21.2732V8.9667C6.66663 8.7826 6.81586 8.63336 6.99996 8.63336H22.383Z",
  fill: "white"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(FormstackIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;